// Function to get the most recent line from live_scoreboard or lines table
export const getLiveLine = (game, lineType) => {
  return game.live_scoreboard?.[lineType] ?? (lineType === 'spread' ? game.spread : game.over_under);
};

// Function to format line display
export const formatLine = (line) => {
    if (line === 0) return 'PK';
    return line > 0 ? `+${line}` : `${line}`;
};

// Function to calculate line movement
export const calculateLineMovement = (liveLine, watchLine) => {
    return liveLine - watchLine;
};

// Function to get home and away spreads
export const getSpreads = (game) => {
    const spread = getLiveLine(game, 'spread');
    return {
      homeSpread: formatLine(spread),
      awaySpread: formatLine(-spread)
    };
};

// Function to get over/under
export const getOverUnder = (game) => {
    return getLiveLine(game, 'over_under');
};

// Updated function to get the correct live line based on pick type and liveLine
export const getCorrectLiveLine = (liveLine, pickType) => {
  switch(pickType) {
    case 'home':
      return liveLine;
    case 'away':
      return -liveLine;
    case 'over':
    case 'under':
      return liveLine;
    default:
      console.error('Invalid pick type:', pickType);
      return null;
  }
};

// Function to generate formatted messages for line verification
export const formatLineVerificationMessage = (game, pickType, currentLine, lockLine) => {
  if (!game) return '';

  // For over/under picks
  if (pickType === 'over' || pickType === 'under') {
    const prefix = pickType === 'over' ? 'O' : 'U';
    const teams = `${game.away_team_abv}v${game.home_team_abv}`;
    return `${prefix}${lockLine} → ${prefix}${currentLine} ${teams}`;
  }

  // For spread picks
  const teamName = pickType === 'home' ? game.home_team : game.away_team;
  const arrow = ' → ';
  const oldLine = formatLine(pickType === 'home' ? lockLine : -lockLine);
  const newLine = formatLine(pickType === 'home' ? currentLine : -currentLine);

  return `${teamName} ${oldLine}${arrow}${newLine}`;
};

// Add these utility functions
export const calculateMargin = (homeScore, awayScore, spread) => {
  return (homeScore - awayScore) + spread;
};

export const calculateOverUnderDiff = (homeScore, awayScore, overUnder) => {
  return overUnder ? (homeScore + awayScore) - overUnder : null;
};

export const getScoreColor = (score, opposingScore) => {
  if (score >= opposingScore) return 'positiveMargin';
  if (score < opposingScore) return 'negativeMargin';
  return '';
};

// Add this utility function
export const getPickTypeDisplay = (pickType, game) => {
  switch(pickType) {
    case 'over': return 'O';
    case 'under': return 'U';
    case 'home': return game.home_team_abv;
    case 'away': return game.away_team_abv;
    default: return '';
  }
};
